"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUITE_ENTERPRISE_MC = exports.SUITE_PROFESSIONAL_MC = exports.SUITE_STARTER_COVID_MC = exports.SUITE_STARTER_MC = exports.COVID_PROMO_SUITE_STARTER = exports.CMS_HUB_MARKETING_STARTER = exports.BUNDLE = exports.SUITE_ENTERPRISE = exports.SUITE_PROFESSIONAL = exports.SUITE_STARTER = void 0;
var SUITE_STARTER = 'growthstarter';
exports.SUITE_STARTER = SUITE_STARTER;
var SUITE_PROFESSIONAL = 'growthprofessional';
exports.SUITE_PROFESSIONAL = SUITE_PROFESSIONAL;
var SUITE_ENTERPRISE = 'growthenterprise';
exports.SUITE_ENTERPRISE = SUITE_ENTERPRISE;
var BUNDLE = 'bundle';
exports.BUNDLE = BUNDLE;
var CMS_HUB_MARKETING_STARTER = 'marketingstartercmshub';
exports.CMS_HUB_MARKETING_STARTER = CMS_HUB_MARKETING_STARTER;
var COVID_PROMO_SUITE_STARTER = 'growthstarter-covid';
exports.COVID_PROMO_SUITE_STARTER = COVID_PROMO_SUITE_STARTER;
var SUITE_STARTER_MC = 'growthstarter-mc';
exports.SUITE_STARTER_MC = SUITE_STARTER_MC;
var SUITE_STARTER_COVID_MC = 'growthstarter-mc-covid';
exports.SUITE_STARTER_COVID_MC = SUITE_STARTER_COVID_MC;
var SUITE_PROFESSIONAL_MC = 'growthprofessional-mc';
exports.SUITE_PROFESSIONAL_MC = SUITE_PROFESSIONAL_MC;
var SUITE_ENTERPRISE_MC = 'growthenterprise-mc';
exports.SUITE_ENTERPRISE_MC = SUITE_ENTERPRISE_MC;